module.exports = __webpack_public_path__ + "static/media/siddharth-coorg-trip-10.792fc6c4.png";